<template>
  <table :class="classes">
    <tbody>
      <tr
        v-for="{ day, times, isToday } in formattedHours"
        :key="day"
        class="opening-hours__row"
        :class="{ 'opening-hours__row--today': isToday }"
        data-test-id="opening-hours-row"
      >
        <td
          :aria-label="getAccessibleDayLabel(day, isToday)"
          class="opening-hours__day"
          data-test-id="opening-hours-day"
        >
          {{ day }}
        </td>
        <td class="opening-hours__hours" data-test-id="opening-hours-times">
          <template v-if="times.periods.length > 0">
            <span
              v-for="period in times.periods"
              :key="period.start"
              class="opening-hours__period"
            >
              {{ period.start }} - {{ period.end }}
            </span>
          </template>
          <template v-else>
            {{ $t('web.entities.tripadvisor.closed') }}
          </template>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapState } from 'vuex';
import upperFirst from 'lodash/upperFirst';

import { localiseWeekday } from '~~/common/js/universal/datetime';
import classes from '~~/common/vue/mixins/classes';

const isOpeningHoursTimes = (times) => Array.isArray(times.periods);

export default {
  name: 'EOpeningHours',
  mixins: [classes],
  props: {
    openingHours: {
      type: Object,
      required: true,
      validator: (openingHours) => openingHours &&
        Object.values(openingHours).every(isOpeningHoursTimes),
    },
    today: {
      type: [Number, null],
      default: null,
    },
  },
  computed: {
    ...mapState('global', ['locale']),
    formattedHours() {
      const rows = Object.entries(this.openingHours).map(([, times], index) => ({
        // even for languages where day names are not capitalised,
        // we should capitalise them in the table
        day: upperFirst(localiseWeekday(this.locale, index)),
        isToday: this.today === index,
        times,
      }));

      return rows;
    },
  },
  methods: {
    getAccessibleDayLabel(day, isToday) {
      return isToday ?
        `${this.$t('web.entities.tripadvisor.today')} - ${day}` :
        day;
    },
  },
};
</script>

<style lang="scss" scoped>
.opening-hours {
  padding: 0 0 $space-m;
  border-spacing: 0 $space-2s;
}

.opening-hours__row--today {
  font-weight: $font-weight-1l;
}

.opening-hours__day,
.opening-hours__hours {
  padding: 0;
  width: 50%;
}

.opening-hours__day {
  padding: 0 $space-m 0 0;
  vertical-align: top;
}

.opening-hours__hours {
  // allows longer opening times (e.g. including AM/PM) not to wrap
  white-space: nowrap;
}

.opening-hours__period {
  display: block;
}
</style>
